<template>
  <div class="h-full">
    <SinglePOI v-if="currentPOI" :currentPOI="currentPOI" :setCurrentPOI="backFromPOI"></SinglePOI>
    <div class="search-page h-full flex flex-col">
      <div class="search-input-container flex items-center gap-12" v-if="!(currentPOI || chooseRoute)">
        <div class="wf-search-input-container" >
          <input type="text" :placeholder="getTypeTextPlaceholder()" id="search-output"
            class="h-64 p-8 transition-width w-full" />
          <svg class="w-32 h-32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M26 13C26 15.8687 25.0688 18.5188 23.5 20.6688L31.4125 28.5875C32.1937 29.3687 32.1937 30.6375 31.4125 31.4188C30.6313 32.2 29.3625 32.2 28.5812 31.4188L20.6688 23.5C18.5188 25.075 15.8687 26 13 26C5.81875 26 0 20.1812 0 13C0 5.81875 5.81875 0 13 0C20.1812 0 26 5.81875 26 13ZM13 22C14.1819 22 15.3522 21.7672 16.4442 21.3149C17.5361 20.8626 18.5282 20.1997 19.364 19.364C20.1997 18.5282 20.8626 17.5361 21.3149 16.4442C21.7672 15.3522 22 14.1819 22 13C22 11.8181 21.7672 10.6478 21.3149 9.55585C20.8626 8.46392 20.1997 7.47177 19.364 6.63604C18.5282 5.80031 17.5361 5.13738 16.4442 4.68508C15.3522 4.23279 14.1819 4 13 4C11.8181 4 10.6478 4.23279 9.55585 4.68508C8.46392 5.13738 7.47177 5.80031 6.63604 6.63604C5.80031 7.47177 5.13738 8.46392 4.68508 9.55585C4.23279 10.6478 4 11.8181 4 13C4 14.1819 4.23279 15.3522 4.68508 16.4442C5.13738 17.5361 5.80031 18.5282 6.63604 19.364C7.47177 20.1997 8.46392 20.8626 9.55585 21.3149C10.6478 21.7672 11.8181 22 13 22Z"
              fill="#9C9EBB" />
          </svg>
        </div>
        <div class="basis-56 shrink-0 grow-1">
          <div class="routechooser-btn w-56 h-56 p-8 flex items-center justify-center" @click="chooseRoute = true">
            <svg class="w-24 h-24" fill="none" version="1.1" viewBox="0 0 65.162 67.409"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="m31.126 0h-0.0137v11.747h-22.682c-4.6506 0-8.4309 3.736-8.4309 8.3621v47.3h15.937v-40.934h15.121v11.747s0 0.01348 0.0137 0l34.09-19.111v-0.02696z"
                fill="#fff" />
            </svg>
          </div>
        </div>
      </div>
      <div v-if="chooseRoute" class="flex flex-col gap-12">
        <div class="back-wrapper flex">
          <div @click="chooseRoute = false" class="group-back-button flex flex-row shrink-1 self-start">
            <svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.366211 8.61719C-0.12207 9.10547 -0.12207 9.89844 0.366211 10.3867L7.86621 17.8867C8.35449 18.375 9.14746 18.375 9.63574 17.8867C10.124 17.3984 10.124 16.6055 9.63574 16.1172L3.01855 9.5L9.63184 2.88281C10.1201 2.39453 10.1201 1.60156 9.63184 1.11328C9.14355 0.625 8.35059 0.625 7.86231 1.11328L0.362305 8.61328L0.366211 8.61719Z" fill="#0F417C"/>
            </svg>
            <WFTranslate k="back">Back</WFTranslate>
          </div>
        </div>
        <WFRouteChooser @showPath="showPath" :showAccessabilityToggle="false"></WFRouteChooser>
      </div>
      <WFSearch class="flex-1" :class="{ accessibleSearch: accessibleLayout && !mobile }" ref="search"
        v-if="!currentPOI && !chooseRoute" :showKeyboard="!mobile" :showLogo="true" :showName="true"
        :showOutputField="false" @clicked="onPOIClick">
        <template v-slot="slotProps">
          <ListPOI :poi="slotProps.poi" @onPOIClick="onPOIClick(poi)" class="wf-list-item"></ListPOI>
        </template>
      </WFSearch>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ListPOI from '@/components/ListPOI'
import SinglePOI from "@/components/SinglePOI";

export default {
  components: {
    ListPOI,
    SinglePOI
  },
  props: ['accessibleLayout'],
  computed: {
    ...mapState('wf', ['language', 'pois', 'mobile'])
  },
  data() {
    return {
      currentTab: "all",
      shortcuts: false,
      currentGroup: null,
      currentPOI: null,
      chooseRoute: false
    }
  },
  watch: {
    '$store.state.currentPage': function () {

    },
  },
  mounted() {
    this.$nextTick(() => {

      this.$refs.search.addLayout('en', {
        "name": "English",
        "keyboard": "US International",
        "local_name": "English",
        "lang": "en",
        "keys": {
          "default": [
            ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
            ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
            ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
            ["z", "x", "c", "v", "b", "n", "m", { "key": "\u00AB", "action": ["backspace"] }],
            [{ "key": "\u02FD", "cls": "key_spacebar" }]
          ]
        }
      });
      this.$refs.search.addLayout('lt', {
        "name": "Lithuanian",
        "keyboard": "US International",
        "local_name": "Lithuanian",
        "lang": "lt",
        "keys": {
          "default": [
            ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
            ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
            ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
            ["z", "x", "c", "v", "b", "n", "m", { "key": "\u00AB", "action": ["backspace"] }],
            [{ "key": "\u02FD", "cls": "key_spacebar" }]
          ]
        }
      });
      this.$refs.search.setOutput('search-output');
      this.$refs.search.resetValues();
    });
  },
  methods: {
    getTypeTextPlaceholder() {
      return this.$wayfinder.translator.get('type-a-keyword');
    },
    backFromPOI() {
      this.currentPOI = null;
      this.$store.dispatch('setCurrentPage', 'info');
      const self = this;
      setTimeout(function () {
        self.$store.dispatch('setCurrentPage', 'search');
      }, 50);
    },
    onPOIClick(poi) {
      this.currentPOI = poi;
    },
    filterAll() {
      this.$store.dispatch('wf/SET_FILTERED_POIS', this.pois);
      this.currentGroup = null;

      if (this.$refs["searchscroll"]) {
        this.$refs["searchscroll"].reset();
      }
    },
    showPath(a, b) {
      if (a && b) {
        this.$emit("close");
        this.$wayfinder.showPathFromPOIToPOI(a, b);
      }
      
    }
  }
}
</script>

<style lang="postcss">
.search-page {
  position: relative;
  height: 100%;

  .accessibleSearch {
    .wf-keyboard {
      position: fixed;
      bottom: 10rem;
      left: 50%;
      margin-left: -40rem;
      background: #fff;
      border-radius: 5rem;
      padding: 5rem;
      height: auto !important;
    }
  }

  .search-input-container {
    height: 6rem;
    width: 100%;
  }

  .wf-search {
    overflow: hidden;

    .wf-search-container {
      padding-top: 10rem;
      display: flex;
      flex-direction: column;
      align-content: stretch;

      .wf-search-results {
        overflow-y: auto;
        flex-grow: 1;
        text-align: center;


      }

      .wf-no-results {
        padding-top: 25%;

        .wf-search-no-results-text {

          flex-direction: column;
          color: #9C9EBB;
          font-size: 2.2rem;
          height: 100%;

          &:before {
            content: "";
            display: block;
            background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMgSURBVHgBzZlRTttAEIb/WTtVH/oQbpCcgHACEgloUV/KDTAhSDwFTkA4QZOnPgQIPQHtE1JBarhBegLSE+AHKlWQeDrrYErABMe7Cv4ky+tdZz3M7M7ODISUtNunZSi3RMAiiErSlQc4PxolX9p9MPqM4BeCoFurrXaRAprm5U7nJB/gXZ2Zdv4Lk/hTfSJ0b/7e7m9vr/YT/yrJS3eC7TFjBxYgouOkgr4o4EHnvC6makyvsRc/3Q842N+qrhxPfGvS4GHn7LMtrT0rAKFZ9ZZ3nx2P69QmHfK7E2mWMRt6DrkVz6v4jwdU3Nsi3E/MTjhNaciDk7iBJwJqs+ofYPaU7749xpiJDw9/rDNRB68I83C3Vv3QjJ7vBfzSOS3kOCem5QJeF1/WYzFaj/cmziG3ZyQc0zeHruduaVCUpy7SIz53sBc9hBocac+9hAEB3SxseR97tuYTLc5pLYYaHGnPDDV8ewWLDIKb0P+OTMwzdSmJIFJ1fVft9lk5AxsjjryOmBRUUEZWUVRSpNQ8sgqRaJBRQEZRcOb1Jikgo7CEeFpAy3GeVfIKGUcL6MMKg4Wo9SZwyrCDTxLSX0oIUYAFdK4hK8eXpGrdSopA6LkykT4/C7AAM6/ftWAD5uC34gAXyCqMnkKAHqzALR1u6UsSrX3YQBL+MNw6ODrTkUjqNSPVg++1jfefHvbJnIZ5Dfc3N1aKoZuRv7gFE/ipFWT9GC0diWa6+h4K6Cq3CQNkssUnfYZnvK48hPNEHQdH5yIk15ESScAbCtehJUzLJNpdVb0lT7fvTxKHnAYMnLYI1JB8+kpfZtUI7kfaGxNQx//Wdp8BgcjwsKg0dhbXqstiZjLbMEZw63ExKbY2Y+4i0sA9cSsLj3tjoxlJ+dbkZsmBJ6Lr0J9K3MDE8pvpzk4Gt0Rzz26qifHg5sbSDjF7Yb3ZPnpT7k4STvNiwFqVRXtLw4qE319hjfDcLo425WSmKqLrkobLTiOs7IMKmA6tsZarrpuet5bY304l4EPChF9yapLMCxQGvPqKAg4//FeEnNGi+QsdMdVqy12k4B+v/jtryLRA+gAAAABJRU5ErkJggg==');
            width: 4rem;
            height: 4rem;
            margin: 0 auto;
            background-repeat: no-repeat;
            background-size: contain;
          }
        }
      }



      .wf-keyboard {
        height: 20rem;
        gap: 0.4rem;
      }
    }
  }


  .wf-search-input-container {
    position: relative;
    width: 100%;

    input {
      width: 100%;
      border-bottom: 0.2rem solid #9C9EBB !important;
      font-size: 2.2rem;
      color: #0F417C;
      font-weight: 600;
    }

    svg {
      position: absolute;
      right: 3rem;
      top: 50%;
      margin-top: -1.6rem;
    }
  }



  .keyboard-row {
    gap: 0.4rem;
    width: 100%;
    justify-content: center;
  }

  .keyboard-key {
    background-color: white;
    width: 4.6rem !important;
    height: 4.6rem !important;
    border-radius: 3.2rem !important;
    line-height: 4.8rem !important;
    border: 1px solid #D3DAE6 !important;
    font-size: 2rem;
    color: #0F417C;
    font-weight: 700;
    text-transform: uppercase;
  }

  .keyboard-key:active {
    background-color: var(--th-active);
    color: var(--th-active-content)
  }

  .keyboard-key_spacebar {
    width: 80% !important;
    font-size: 400%;
    line-height: 0.3 !important;
  }

  .pois-content {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    overflow: hidden;
  }

  .poi-groups {
    padding: 1rem;
  }

  .poi-groups .wf-list {
    display: grid;
    gap: 1.2rem;
    grid-template-columns: 1fr 1fr 1fr;
  }

  .poi-groups .wf-list-item {
    height: 3.6em;
    padding: 0.4em;
    font-weight: 500;
    text-align: center;
    line-height: 1.4em;
    vertical-align: middle;

    display: flex;
    flex-direction: column;
    justify-content: center;

    &.active {
      background-color: black;
      color: white;
    }
  }

  .wf-route-chooser {
    gap: 0.8rem;
    display: flex;
    flex-direction: column;
    font-size: 1.6rem;

    .wf-button {
      background: #0F417C;
      color: #fff;
      display: inline-block;
      padding: 1rem 2rem;
      border-radius: 2.4rem;
      font-size: 1.8rem;
      font-weight: 600;
      display: block;
    }
  }



  .wf-dropdown-input,
  .wf-dropdown-menu {
    font-size: 1.8rem;
  }

  .routechooser-btn {
    border-radius: 50%;
    border: 1px solid #0F417C;
    background-color: #0F417C;
    ;
  }
}
</style>
